import { createSlice } from '@reduxjs/toolkit';
import { update } from 'lodash';

const initialState = {
  supportedDigimoneyMethods: [],
  supportedLencoDepositBanks: [],
  supportedLencoWithdrawBanks: [],
  supportedLencoWithdrawMobile: [],

  supportedDepositMethods: [],
  supportedWithdrawMethods: [],
  supportedMethods: [],
};

export const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    updateSupportedDigimoneyMethods: (state, action) => {
      state.supportedDigimoneyMethods =
        action.payload !== undefined ?? action.payload[0];
    },
    updateSupportedLencoDepositBanks: (state, action) => {
      state.supportedLencoDepositBanks =
        action.payload !== undefined ?? action.payload[0];
    },
    updateSupprotedLencoWithdrawBanks: (state, action) => {
      state.supportedLencoWithdrawBanks =
        action.payload !== undefined ?? action.payload[0];
    },
    updateSupprotedLencoWithdrawMobile: (state, action) => {
      state.supportedLencoWithdrawMobile =
        action.payload !== undefined ?? action.payload[0];
    },
    updateSupportedDepositMethods: (state, action) => {
      state.supportedDepositMethods = action?.payload[0];
    },
    updateSupportedWithdrawMethods: (state, action) => {
      state.supportedWithdrawMethods = action.payload[0];
    },
    // updateSupportedChappaMethods: (state, action) => {
    //   state.supportedChappaMethods = action.payload[0];
    // },
    updateSupportedMethods: (state, action) => {
      state.supportedMethods = action?.payload;
    },
  },
});

export const {
  updateSupportedDepositMethods,
  updateSupportedWithdrawMethods,
  updateSupportedDigimoneyMethods,
  updateSupprotedLencoWithdrawBanks,
  updateSupprotedLencoWithdrawMobile,
  updateSupportedLencoDepositBanks,
  updateSupportedMethods,
} = walletSlice.actions;

export default walletSlice.reducer;
